import reqest from "../common/reqest";


/**
 * 获取最近一次直播间布展信息
 * @param data
 * @returns {Promise<unknown>}
 */
export function getPrevBrocastInfo(data) {
  return reqest.send("/Pub/getPrevBrocastInfo", data)
}


/**
 * 直播间预约设置
 * @param data
 * @returns {Promise<unknown>}
 */
export function newSubject(data) {
  return reqest.send("/Pub/newSubject", data)
}

/**
 * 直播间预约设置
 * @param data
 * @returns {Promise<unknown>}
 */
export function subject_set(data) {
  return reqest.send("/Pub/subject_set", data)
}

/**
 * 直播间论坛列表
 * @param data
 * @returns {Promise<unknown>}
 */
export function getBroadcastList(data) {
  return reqest.send("/Pub/Broadcast_SelectList", data)
}

/**
 * 直播间列表
 * @param data
 * @returns {Promise<unknown>}
 */
export function CompanySelectList(data) {
  return reqest.send("/Pub/Company_SelectList",data)
}

/**
 * 获取直播间进入链接
 * @param data
 * @returns {Promise<unknown>}
 */
export function getLiveUrl(data) {
  return reqest.send("/Live/Live_Url",data)
}

/**
 * 获取是否可以无票进入直播间
 * @param {*} data 
 */
export function liverRoomBuy(data) {
  return reqest.send("/Pub/liverRoomBuy",data)
}

/**
 * 获取新直播间进入链接
 * @param data
 * @returns {Promise<unknown>}
 */
export function getNewLiveUrl(data) {
  return reqest.send("/Luntan/Luntan",data)
}

/**
 * 获取新直播间进入链接
 * @param data
 * @returns {Promise<unknown>}
 */
export function ClearQueue(data) {
  return reqest.send("/Gateway/Clear_Queue",data)
}


/**
 * 直播间角色验证
 * @param data
 * @returns {Promise<unknown>}
 */
export function checkUser(data) {
   return reqest.send("/Live/Check_User", data)
}

/**
 * 查看联系方式
 * @param data
 * @returns {Promise<unknown>}
 */
export function selectContact(data) {
  return reqest.send("/BroadcastBbs/See_Contact", data)
}


/**
 * 直播间参展用户列表
 * @param data
 * @returns {Promise<unknown>}
 */
export function getLiveUser(data) {
  return reqest.send("/LiveOperation/Live_User_List", data)
}


/**
 * 直播间参展用户进入和离开时间列表
 * @param data
 * @returns {Promise<unknown>}
 */
export function getLiveTime(data) {
  return reqest.send("/LiveOperation/Live_User_Time_List", data)
}

/**
 * 直播间回放列表
 * @param data
 * @returns {Promise<unknown>}
 */
export function callbackPlay(data) {
  return reqest.send("/LiveOperation/Callback_Play", data)
}

/**
 * 获取直播间回放视频地址
 * @param data
 * @returns {Promise<unknown>}
 */
export function callbackPlatVodio(data) {
  return reqest.send("/LiveOperation/Callback_Play_vodio", data)
}

/**
 * 上传图片
 * @param data
 * @returns {Promise<unknown>}
 */
export function uploadImage(data) {
  return reqest.send("/Publicother/uploadpic", data)
}

/**
 * 获取排队历史数据
 * @param {*} data 
 */
export function LiveRoomLineHistory(data) {
  return reqest.send("/Pub/LiveRoomLineHistory",data)
}

/**
 * 获取线下预约数据
 * @param {*} data 
 */
export function LiveRoomPrivateTalk(data) {
  return reqest.send("/Pub/LiveRoomPrivateTalk",data)
}


/**
 * 获取直播间分享图片数据
 * @param {*} data 
 */
export function getExhibitionRrk(data) {
  return reqest.send("/MakeQr/getExhibitionRrk",data)
}


/**
 * 获取公司下直播间
 * @param data
 * @returns {Promise<unknown>}
 */
export function showBroadCast(data) {
  return reqest.send("/Pub/showBroadCast",data,true)
}

/**
 * 获取显示国内外展商
 * @param data
 * @returns {Promise<unknown>}
 */
export function getCountryState(data) {
  return reqest.send("/Pub/get_country_state",data)
}

/**
 * 获取显示国内外展商
 * @param data
 * @returns {Promise<unknown>}
 */
export function addBroadcastSubscribe(data) {
  return reqest.send("/Exhibition/add_broadcast_subscribe",data)
}

/**
 * 查询轮播
 */
export function getBannerList(data) {
    return reqest.send("/Pub/get_banner_list", data);
}
/**
 * 查询已购买的票数量
 */
export function getExhticketUserCount(data) {
    return reqest.send("/Pub/get_exhticket_user_count", data);
}

//展会说明页
export function getAdintroduceList(data) {
  return reqest.send("/Ad/get_adbasinfo_list", data);
}

//logo展商广告（6个logo广告）
export function getExhibitorsLogoList(data) {
  return reqest.send("/Ad/get_adinfo", data);
}
